export const INPUT_NAMES = {
	USERNAME: "username",
	PASSWORD: "password"
}